import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { getContacts, Contact } from "../api/contact";
import { useEffect, useState, useCallback } from "react";

export function useContacts(userId: string, careRecipient: CareRecipient | null) {

    const [contacts, setContacts] = useState<Contact[]>([]);
    const get = useCallback(async () => {
        if (!careRecipient) return;
        const data = await getContacts(userId, careRecipient.id.value);
        setContacts(data);
    }, [userId, careRecipient]);

    useEffect(() => {
        get();
    }, [userId, careRecipient]);

    return { contacts, reload: get };

}
